export const BAND_ACTION_PREFIX = "bandData";

const BAND_ACTIONS_PERMISSIONS = {
  getPermissionTypes: `${BAND_ACTION_PREFIX}/permissionTypes/get`,
  getBandUsersPermissions: `${BAND_ACTION_PREFIX}/bandUsersPermissions/get`,
  getUserPermissions: `${BAND_ACTION_PREFIX}/userPermission/get`,
  editUserPermissions: `${BAND_ACTION_PREFIX}/userPermission/edit`,
};

export const USER_ACTIONS = {
  getUser: `${BAND_ACTION_PREFIX}/user/get`,
  editUser: `${BAND_ACTION_PREFIX}/user/edit`,
  // address
  getUserAddresses: `${BAND_ACTION_PREFIX}/getUserAddresses`,
  createUserAddress: `${BAND_ACTION_PREFIX}/createUserAddress`,
  editUserAddress: `${BAND_ACTION_PREFIX}/editUserAddress`,
  deleteUserAddress: `${BAND_ACTION_PREFIX}/deleteUserAddress`,
  // phone number
  getUserPhoneNumbers: `${BAND_ACTION_PREFIX}/getPhoneNumbers`,
  createUserPhoneNumber: `${BAND_ACTION_PREFIX}/createPhoneNumber`,
  editUserPhoneNumber: `${BAND_ACTION_PREFIX}/editPhoneNumber`,
  deleteUserPhoneNumber: `${BAND_ACTION_PREFIX}/deletePhoneNumber`,
  // emergency contact
  getUserEmergencyContacts: `${BAND_ACTION_PREFIX}/getUserEmergencyContacts`,
  createUserEmergencyContact: `${BAND_ACTION_PREFIX}/createUserEmergencyContact`,
  editUserEmergencyContact: `${BAND_ACTION_PREFIX}/editUserEmergencyContact`,
  deleteUserEmergencyContact: `${BAND_ACTION_PREFIX}/deleteUserEmergencyContact`,
  // home base
  getUserHomeBases: `${BAND_ACTION_PREFIX}/getUserHomeBases`,
  createUserHomeBase: `${BAND_ACTION_PREFIX}/createUserHomeBase`,
  editUserHomeBase: `${BAND_ACTION_PREFIX}/editUserHomeBase`,
  deleteUserHomeBase: `${BAND_ACTION_PREFIX}/deleteUserHomeBase`,
  // passport
  getUserPassports: `${BAND_ACTION_PREFIX}/getUserPassports`,
  createUserPassport: `${BAND_ACTION_PREFIX}/createUserPassport`,
  editUserPassport: `${BAND_ACTION_PREFIX}/editUserPassport`,
  deleteUserPassport: `${BAND_ACTION_PREFIX}/deleteUserPassport`,
  // travel visa
  getUserTravelVisas: `${BAND_ACTION_PREFIX}/getUserTravelVisas`,
  createUserTravelVisa: `${BAND_ACTION_PREFIX}/createUserTravelVisa`,
  editUserTravelVisa: `${BAND_ACTION_PREFIX}/editUserTravelVisa`,
  deleteUserTravelVisa: `${BAND_ACTION_PREFIX}/deleteUserTravelVisa`,
  // social security forms
  getUserSocialSecurityForms: `${BAND_ACTION_PREFIX}/getUserSocialSecurityForms`,
  createUserSocialSecurityForm: `${BAND_ACTION_PREFIX}/createUserSocialSecurityForm`,
  editUserSocialSecurityForm: `${BAND_ACTION_PREFIX}/editUserSocialSecurityForm`,
  deleteUserSocialSecurityForm: `${BAND_ACTION_PREFIX}/deleteUserSocialSecurityForm`,
  // driving permit
  getUserDrivingPermits: `${BAND_ACTION_PREFIX}/getUserDrivingPermits`,
  createUserDrivingPermit: `${BAND_ACTION_PREFIX}/createUserDrivingPermit`,
  editUserDrivingPermit: `${BAND_ACTION_PREFIX}/editUserDrivingPermit`,
  deleteUserDrivingPermit: `${BAND_ACTION_PREFIX}/deleteUserDrivingPermit`,
  // vehicle
  getUserVehicles: `${BAND_ACTION_PREFIX}/getUserVehicles`,
  createUserVehicle: `${BAND_ACTION_PREFIX}/createUserVehicle`,
  editUserVehicle: `${BAND_ACTION_PREFIX}/editUserVehicle`,
  deleteUserVehicle: `${BAND_ACTION_PREFIX}/deleteUserVehicle`,
  // loyalty program
  getUserLoyaltyPrograms: `${BAND_ACTION_PREFIX}/getUserLoyaltyPrograms`,
  createUserLoyaltyProgram: `${BAND_ACTION_PREFIX}/createUserLoyaltyProgram`,
  editUserLoyaltyProgram: `${BAND_ACTION_PREFIX}/editUserLoyaltyProgram`,
  deleteUserLoyaltyProgram: `${BAND_ACTION_PREFIX}/deleteUserLoyaltyProgram`,
};

export const BAND_ACTIONS = {
  ...BAND_ACTIONS_PERMISSIONS,
  getAdminBands: `${BAND_ACTION_PREFIX}/adminBands/get`,
  getUserBands: `${BAND_ACTION_PREFIX}/userBands/get`,
  getBandUsers: `${BAND_ACTION_PREFIX}/bandUser/list`,
  getMyBandUsers: `${BAND_ACTION_PREFIX}/bandUser/me`,
  editBandUser: `${BAND_ACTION_PREFIX}/bandUser/edit`,
  deleteBandUser: `${BAND_ACTION_PREFIX}/bandUser/delete`,
  getBand: `${BAND_ACTION_PREFIX}/band/get`,
  editBand: `${BAND_ACTION_PREFIX}/band/edit`,
  deleteBand: `${BAND_ACTION_PREFIX}/band/delete`,
  createBand: `${BAND_ACTION_PREFIX}/bands/create`,
  isOnlyBandUser: `${BAND_ACTION_PREFIX}/isOnlyBandUser`,
  getEventTypes: `${BAND_ACTION_PREFIX}/event_types/list`,
  editEventTypes: `${BAND_ACTION_PREFIX}/event_types/edit`,
  editTicketAndPassTypes: `${BAND_ACTION_PREFIX}/ticket_and_pass_types/edit`,
  editMemberCategories: `${BAND_ACTION_PREFIX}/member_categories/edit`,
  editInfoBlockTypes: `${BAND_ACTION_PREFIX}/info_block_types/edit`,
  getEvent: `${BAND_ACTION_PREFIX}/event/get`,
  getEvents: `${BAND_ACTION_PREFIX}/event/list`,
  createEvent: `${BAND_ACTION_PREFIX}/event/create`,
  editEvent: `${BAND_ACTION_PREFIX}/event/edit`,
  deleteEvent: `${BAND_ACTION_PREFIX}/event/delete`,
  createCompany: `${BAND_ACTION_PREFIX}/company/create`,
  editCompany: `${BAND_ACTION_PREFIX}/company/edit`,
  getCompany: `${BAND_ACTION_PREFIX}/company/get`,
  getUserCompanies: `${BAND_ACTION_PREFIX}/userCompanies/get`,
  createBandSubscription: `${BAND_ACTION_PREFIX}/bandSubscription/create`,
  editBandSubscription: `${BAND_ACTION_PREFIX}/bandSubscription/edit`,
  cancelBandSubscription: `${BAND_ACTION_PREFIX}/bandSubscription/cancel`,
  getSubscriptions: `${BAND_ACTION_PREFIX}/subscriptions/get`,
  editSubscriptionPayment: `${BAND_ACTION_PREFIX}/subscriptionPayment/edit`,
  getCompanyInvoices: `${BAND_ACTION_PREFIX}/companyInvoices/get`,
  getInvoice: `${BAND_ACTION_PREFIX}/invoice/get`,
  getCompanySubscriptions: `${BAND_ACTION_PREFIX}/companySubscriptions/get`,
  getPaymentInfo: `${BAND_ACTION_PREFIX}/companySubscriptions/getPaymentInfo`,
  startTrial: `${BAND_ACTION_PREFIX}/startTrial`,
  editTrial: `${BAND_ACTION_PREFIX}/editTrial`,
  getCustomSubscriptionRequests: `${BAND_ACTION_PREFIX}/customSubscriptionRequests/get`,
  deleteCustomSubscriptionRequest: `${BAND_ACTION_PREFIX}/customSubscriptionRequests/delete`,
  createCustomSubscription: `${BAND_ACTION_PREFIX}/customSubscription/create`,
  editCustomSubscription: `${BAND_ACTION_PREFIX}/customSubscription/edit`,
  requestCustomSubscription: `${BAND_ACTION_PREFIX}/customSubscription/request`,
  createBandInvitation: `${BAND_ACTION_PREFIX}/bandInvitation/create`,
  getBandInvitation: `${BAND_ACTION_PREFIX}/bandInvitation/get`,
  editBandInvitation: `${BAND_ACTION_PREFIX}/bandInvitation/edit`,
  deleteBandInvitation: `${BAND_ACTION_PREFIX}/bandInvitation/delete`,
  sendBandInvitation: `${BAND_ACTION_PREFIX}/bandInvitation/send`,
  acceptBandInvitation: `${BAND_ACTION_PREFIX}/bandInvitation/accept`,
  revokeBandInvitation: `${BAND_ACTION_PREFIX}/bandInvitation/revoke`,
  getPendingBandInvitations: `${BAND_ACTION_PREFIX}/bandInvitation/get/pending`,
  getSentBandInvitations: `${BAND_ACTION_PREFIX}/bandInvitation/get/sent`,
  getEventPeopleBlocks: `${BAND_ACTION_PREFIX}/eventPeopleBlock/list`,
  getEventPeopleBlock: `${BAND_ACTION_PREFIX}/eventPeopleBlock/get`,
  createEventPeopleBlock: `${BAND_ACTION_PREFIX}/eventPeopleBlock/create`,
  editEventPeopleBlock: `${BAND_ACTION_PREFIX}/eventPeopleBlock/edit`,
  editEventPeopleBlockTitle: `${BAND_ACTION_PREFIX}/eventPeopleBlock/title/edit`,
  deleteEventPeopleBlock: `${BAND_ACTION_PREFIX}/eventPeopleBlock/delete`,
  addMembersToPeopleBlock: `${BAND_ACTION_PREFIX}/eventPeopleBlock/members/add`,
  editPeopleBlockUser: `${BAND_ACTION_PREFIX}/eventPeopleBlock/user/edit`,
  deletePeopleBlockUser: `${BAND_ACTION_PREFIX}/eventPeopleBlock/user/delete`,
  getEventRSVP: `${BAND_ACTION_PREFIX}/eventPeopleBlock/rsvp/get`,
  answerEventRSVP: `${BAND_ACTION_PREFIX}/eventPeopleBlock/rsvp/answer`,
  getEventScheduleBlocks: `${BAND_ACTION_PREFIX}/eventScheduleBlock/list`,
  getEventScheduleBlock: `${BAND_ACTION_PREFIX}/eventScheduleBlock/get`,
  createEventScheduleBlock: `${BAND_ACTION_PREFIX}/eventScheduleBlock/create`,
  editEventScheduleBlock: `${BAND_ACTION_PREFIX}/eventScheduleBlock/edit`,
  editEventScheduleBlockTitle: `${BAND_ACTION_PREFIX}/eventScheduleBlock/title/edit`,
  deleteEventScheduleBlock: `${BAND_ACTION_PREFIX}/eventScheduleBlock/delete`,
  getEventScheduleBlockEntries: `${BAND_ACTION_PREFIX}/eventScheduleBlock/entry/list`,
  getEventScheduleBlockEntry: `${BAND_ACTION_PREFIX}/eventScheduleBlock/entry/get`,
  createEventScheduleBlockEntry: `${BAND_ACTION_PREFIX}/eventScheduleBlock/entry/create`,
  editEventScheduleBlockEntry: `${BAND_ACTION_PREFIX}/eventScheduleBlock/entry/edit`,
  deleteEventScheduleBlockEntry: `${BAND_ACTION_PREFIX}/eventScheduleBlock/entry/delete`,
  getEventInfoBlocks: `${BAND_ACTION_PREFIX}/eventInfoBlock/list`,
  getEventInfoBlock: `${BAND_ACTION_PREFIX}/eventInfoBlock/get`,
  createEventInfoBlock: `${BAND_ACTION_PREFIX}/eventInfoBlock/create`,
  editEventInfoBlock: `${BAND_ACTION_PREFIX}/eventInfoBlock/edit`,
  deleteEventInfoBlock: `${BAND_ACTION_PREFIX}/eventInfoBlock/delete`,
  getInfoBlockItems: `${BAND_ACTION_PREFIX}/infoBlockItem/list`,
  getInfoBlockItem: `${BAND_ACTION_PREFIX}/infoBlockItem/get`,
  createInfoBlockItem: `${BAND_ACTION_PREFIX}/infoBlockItem/create`,
  editInfoBlockItem: `${BAND_ACTION_PREFIX}/infoBlockItem/edit`,
  deleteInfoBlockItem: `${BAND_ACTION_PREFIX}/infoBlockItem/delete`,
  getEventVenueBlocks: `${BAND_ACTION_PREFIX}/eventVenueBlock/list`,
  getEventVenueBlock: `${BAND_ACTION_PREFIX}/eventVenueBlock/get`,
  createEventVenueBlock: `${BAND_ACTION_PREFIX}/eventVenueBlock/create`,
  editEventVenueBlock: `${BAND_ACTION_PREFIX}/eventVenueBlock/edit`,
  deleteEventVenueBlock: `${BAND_ACTION_PREFIX}/eventVenueBlock/delete`,
  getEventGuestlistBlocks: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/list`,
  getEventGuestlistBlock: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/get`,
  createEventGuestlistBlock: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/create`,
  editEventGuestlistBlock: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/edit`,
  editEventGuestlistBlockTitle: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/title/edit`,
  deleteEventGuestlistBlock: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/delete`,
  downloadEventGuestlistBlock: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/download`,
  getLastGuestlistSent: `${BAND_ACTION_PREFIX}/eventGuestlistBlock/lastSent`,
  getEventTicketAndPasses: `${BAND_ACTION_PREFIX}/eventTicketAndPass/list`,
  getEventTicketAndPass: `${BAND_ACTION_PREFIX}/eventTicketAndPass/get`,
  createEventTicketAndPass: `${BAND_ACTION_PREFIX}/eventTicketAndPass/create`,
  editEventTicketAndPass: `${BAND_ACTION_PREFIX}/eventTicketAndPass/edit`,
  deleteEventTicketAndPass: `${BAND_ACTION_PREFIX}/eventTicketAndPass/delete`,
  getEventGuests: `${BAND_ACTION_PREFIX}/eventGuests/list`,
  getEventGuest: `${BAND_ACTION_PREFIX}/eventGuests/get`,
  createEventGuest: `${BAND_ACTION_PREFIX}/eventGuests/create`,
  editEventGuest: `${BAND_ACTION_PREFIX}/eventGuests/edit`,
  deleteEventGuest: `${BAND_ACTION_PREFIX}/eventGuests/delete`,
  getEventTravelBlocks: `${BAND_ACTION_PREFIX}/eventTravelBlock/list`,
  getEventTravelBlock: `${BAND_ACTION_PREFIX}/eventTravelBlock/get`,
  createEventTravelBlock: `${BAND_ACTION_PREFIX}/eventTravelBlock/create`,
  editEventTravelBlock: `${BAND_ACTION_PREFIX}/eventTravelBlock/edit`,
  editEventTravelBlockTitle: `${BAND_ACTION_PREFIX}/eventTravelBlock/title/edit`,
  deleteEventTravelBlock: `${BAND_ACTION_PREFIX}/eventTravelBlock/delete`,
  getEventAccommodationBlock: `${BAND_ACTION_PREFIX}/eventAccommodationBlock/get`,
  getEventAccommodationBlocks: `${BAND_ACTION_PREFIX}/eventAccommodationBlock/list`,
  createAccommodationBlock: `${BAND_ACTION_PREFIX}/eventAccommodationBlock/create`,
  editAccommodationBlockTitle: `${BAND_ACTION_PREFIX}/eventAccommodationBlock/title/edit`,

  editAccommodationBlock: `${BAND_ACTION_PREFIX}/eventAccommodationBlock/edit`,
  editEventAccommodationBlock: `${BAND_ACTION_PREFIX}/eventAccommodationBlock/edit`,
  deleteAccommodationBlock: `${BAND_ACTION_PREFIX}/eventAccommodationBlock/delete`,

  createAccommodationRoomType: `${BAND_ACTION_PREFIX}/eventAccommodationRoomType/create`,
  editAccommodationRoomType: `${BAND_ACTION_PREFIX}/eventAccommodationRoomType/edit`,
  deleteAccommodationRoomType: `${BAND_ACTION_PREFIX}/eventAccommodationRoomType/delete`,
  getEventAccommodationRoomTypes: `${BAND_ACTION_PREFIX}/eventAccommodationRoomType/list`,

  getEventAccommodationRooms: `${BAND_ACTION_PREFIX}/eventAccommodationRoom/list`,
  getEventAccommodationRoomsForBlock: `${BAND_ACTION_PREFIX}/eventAccommodationRoomForBlock/list`,

  createTravelLeg: `${BAND_ACTION_PREFIX}/travelLeg/create`,
  editTravelLeg: `${BAND_ACTION_PREFIX}/travelLeg/edit`,
  deleteTravelLeg: `${BAND_ACTION_PREFIX}/travelLeg/delete`,

  getEventSuggestedLocations: `${BAND_ACTION_PREFIX}/suggestedLocations/list`,
  getEventGoogleLocations: `${BAND_ACTION_PREFIX}/googleLocations/list`,

  getBandIcal: `${BAND_ACTION_PREFIX}/ical/create`,
  editBandIcal: `${BAND_ACTION_PREFIX}/ical/edit`,

  getTravelBlockPassengers: `${BAND_ACTION_PREFIX}/travelBlockPassenger/list`,
  createTravelBlockPassenger: `${BAND_ACTION_PREFIX}/travelBlockPassenger/create`,
  editTravelBlockPassenger: `${BAND_ACTION_PREFIX}/travelBlockPassenger/edit`,
  deleteTravelBlockPassenger: `${BAND_ACTION_PREFIX}/travelBlockPassenger/delete`,
  fetchPrefillFlight: `${BAND_ACTION_PREFIX}/flights/prefill`,

  editAccommodationReservation: `${BAND_ACTION_PREFIX}/eventAccommodationReservation/edit`,
  deleteAccommodationReservation: `${BAND_ACTION_PREFIX}/eventAccommodationReservation/delete`,
  getEventAccommodationReservations: `${BAND_ACTION_PREFIX}/eventAccommodationReservation/list`,
  createEventAccommodationReservation: `${BAND_ACTION_PREFIX}/eventAccommodationReservation/create`,

  createEventAccommodationReservationWithRoomType: `${BAND_ACTION_PREFIX}/eventAccommodationReservationWithRoomType/create`,

  createEventDetailsExport: `${BAND_ACTION_PREFIX}/eventDetailsExport/create`,
  getEventDetailsExport: `${BAND_ACTION_PREFIX}/eventDetailsExport/get`,

  emailEventDetailsExport: `${BAND_ACTION_PREFIX}/eventDetailsExport/email`,
  getLastEventDetailsExportSent: `${BAND_ACTION_PREFIX}/eventDetailsExport/lastSent`,
  copyEventBlocks: `${BAND_ACTION_PREFIX}/eventBlocks/copy`,
  deleteEventBlock: `${BAND_ACTION_PREFIX}/eventBlocks/delete`,
  createBandExport: `${BAND_ACTION_PREFIX}/bandExport/create`,
};

export type IBandActions = (typeof BAND_ACTIONS)[keyof typeof BAND_ACTIONS];
